import { useId } from 'react'
import { identityFor, identityKeySvg, type KeyOptions } from './Options/visualIdentity.js'

/** A name's chart identity as a legend key: fill square plus line sample. */
export const IdentityKey = ({ name, ...options }: { name: string } & KeyOptions) => {
  const idScope = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  return (
    <span
      aria-hidden="true"
      className="inline-flex shrink-0"
      // Markup comes from identityKeySvg, which emits only colours and fixed geometry, never the name.
      dangerouslySetInnerHTML={{ __html: identityKeySvg(identityFor(name), { ...options, idScope }) }}
    />
  )
}
